import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { TestimonialsSection } from '../components/TestimonialsSection';
export function TestimonialsPage() {
  return <main data-id="element-908">
      <PageBanner title="Client Testimonials" subtitle="Hear what our clients and their families have to say about our care." breadcrumbs={[{
      label: 'Testimonials',
      path: '/testimonials'
    }]} data-id="element-909" />
      <TestimonialsSection data-id="element-910" />
    </main>;
}